var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[(_vm.show_add_view)?_c('add-view'):_vm._e(),(_vm.show_table_view)?_c('department-students'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }